import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  // Header is now global via App.js
  // Re-adding wrapper div for dark theme background
  return (
    <div className="bg-gradient-to-br from-gray-900 to-black text-white"> {/* Removed flex-grow */}
      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 md:py-16"> {/* Removed text-white, inherited now */}
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-center">Privacy Policy</h1>
        <div className="prose prose-invert max-w-3xl mx-auto text-gray-300">
          <p>Last updated: March 28, 2025</p>
          <p>
            Welcome to Headshot AI ("us", "we", or "our"). We operate the Headshot AI website (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
          </p>
          <h2>Information Collection and Use</h2>
          <p>
            We collect several different types of information for various purposes to provide and improve our Service to you. This may include, but is not limited to, email address, usage data, and uploaded images.
          </p>
          <h2>Use of Data</h2>
          <p>
            Headshot AI uses the collected data for various purposes:
            <ul>
              <li>To provide and maintain the Service</li>
              <li>To notify you about changes to our Service</li>
              <li>To provide customer support</li>
              <li>To gather analysis or valuable information so that we can improve the Service</li>
              <li>To monitor the usage of the Service</li>
              <li>To detect, prevent and address technical issues</li>
            </ul>
          </p>
          <h2>Uploaded Images</h2>
          <p>
            Images uploaded to the Service are processed by our AI model to generate headshots. We may temporarily store uploaded images and generated results for operational purposes and service improvement. We are committed to handling your images responsibly. [Placeholder: Add specific details about image retention and usage policy here].
          </p>
          <h2>Security of Data</h2>
          <p>
            The security of your data is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
          </p>
          <h2>Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
          </p>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us: [Placeholder: Add contact information].
          </p>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="py-6 px-6 md:px-10 text-center text-gray-400 border-t border-white/10 mt-auto">
        <p>&copy; 2025 Headshot AI. All rights reserved.</p>
      </footer>
    </div> // Close wrapper div
  );
};

export default PrivacyPolicy;
